module.exports = __webpack_public_path__ + "img/tdgc.79ce53ee.png";